import styled from 'styled-components';

export const BrokerBanner = styled.div`
  display: flex;
  min-height: 50px;
  font-size: 30px;
  text-align: center;
  justify-content: center;
  background: #5084a9;
  color: white;
  align-content: center;
  align-items: center;
  border-radius: 5px;
  margin-bottom: 22px;

  :after {
    content: 'BROKER';
  }
`;
